<template>
  <div class="wizard-body small-9 columns">
    <!-- Sin la app de Meta configurada en el entorno solo existe el alta manual, como siempre. -->
    <template v-if="!hasEmbeddedSignup">
      <page-header
        :header-title="$t('INBOX_MGMT.ADD.WHATSAPP.TITLE')"
        :header-content="$t('INBOX_MGMT.ADD.WHATSAPP.DESC')"
      />
      <div class="medium-8 columns">
        <label>
          {{ $t('INBOX_MGMT.ADD.WHATSAPP.PROVIDERS.LABEL') }}
          <select v-model="provider" disabled>
            <option :value="PROVIDERS.CLOUD">
              {{ $t('INBOX_MGMT.ADD.WHATSAPP.PROVIDERS.WHATSAPP_CLOUD') }}
            </option>
            <option :value="PROVIDERS.TWILIO">
              {{ $t('INBOX_MGMT.ADD.WHATSAPP.PROVIDERS.TWILIO') }}
            </option>
            <option v-if="!isInvisible" :value="PROVIDERS.DIALOG_360">
              {{ $t('INBOX_MGMT.ADD.WHATSAPP.PROVIDERS.360_DIALOG') }}
            </option>
          </select>
        </label>
      </div>

      <twilio v-if="provider === PROVIDERS.TWILIO" type="whatsapp" />
      <three-sixty-dialog-whatsapp
        v-else-if="provider === PROVIDERS.DIALOG_360"
      />
      <cloud-whatsapp v-else />
    </template>

    <!-- Paso 1 del flujo con Embedded Signup: elegir cómo conectar el número. -->
    <template v-else>
      <page-header
        :header-title="$t('INBOX_MGMT.ADD.WHATSAPP.SETUP_PATHS.TITLE')"
        :header-content="$t('INBOX_MGMT.ADD.WHATSAPP.SETUP_PATHS.DESC')"
      />
      <whatsapp-setup-paths @select="goTo" />
    </template>
  </div>
</template>

<script>
import PageHeader from '../../SettingsSubPageHeader';
import Twilio from './Twilio';
import ThreeSixtyDialogWhatsapp from './360DialogWhatsapp';
import CloudWhatsapp from './CloudWhatsapp';
import WhatsappSetupPaths from './whatsapp/WhatsappSetupPaths';
import router from '../../../../index';
import { isEmbeddedSignupAvailable } from './whatsapp/embeddedSignupUtils';
import { WHATSAPP_CONNECT_ROUTE } from '../helpers/whatsappConnectGuard';

// Proveedores del alta clásica (valores del select).
const PROVIDERS = Object.freeze({
  CLOUD: 'whatsapp_cloud',
  TWILIO: 'twilio',
  DIALOG_360: '360dialog',
});

export default {
  components: {
    PageHeader,
    Twilio,
    ThreeSixtyDialogWhatsapp,
    CloudWhatsapp,
    WhatsappSetupPaths,
  },
  data() {
    return {
      PROVIDERS,
      provider: PROVIDERS.CLOUD,
      isInvisible: true,
    };
  },
  computed: {
    hasEmbeddedSignup() {
      return isEmbeddedSignupAvailable();
    },
  },
  methods: {
    // Paso 2 del wizard con el camino elegido en la query; la ruta tiene path propio.
    goTo(path) {
      router.push({
        name: WHATSAPP_CONNECT_ROUTE,
        query: { path },
      });
    },
  },
};
</script>
